import Phaser from 'phaser'
import { Boot } from '@/scenes/Boot'
import { Lobby } from '@/scenes/Lobby'
import { Game } from '@/scenes/Game'
import { UI } from '@/scenes/UI'
import { GameOver } from '@/scenes/GameOver'
import { Leaderboard } from '@/scenes/Leaderboard'
import { Shop } from '@/scenes/Shop'
import { WaitingRoom } from '@/scenes/WaitingRoom'

export const isLargeScreen = Math.min(window.innerWidth, window.innerHeight) >= 600

// 고해상도(레티나) 대응: 캔버스 백킹 스토어를 물리 픽셀로 렌더하고 CSS로 축소.
// Phaser의 Scale.RESIZE는 devicePixelRatio를 무시해 캔버스를 CSS 픽셀 크기로만
// 만들기 때문에, 2x/3x 디스플레이에서 절반 해상도로 렌더되어 흐릿/계단현상이 생긴다.
// dpr은 GPU 비용을 고려해 2로 캡한다.
const dpr = () => Math.min(window.devicePixelRatio || 1, 2)

// 컨테이너 크기를 기준으로 한다(데스크탑/태블릿에서는 CSS가 세로 비율로 가둠).
const containerEl = () => document.getElementById('game-container') as HTMLElement
const containerSize = () => {
  const el = containerEl()
  return {
    w: el?.clientWidth || window.innerWidth,
    h: el?.clientHeight || window.innerHeight,
  }
}

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: '#bfe3ff',
  scale: {
    mode: Phaser.Scale.NONE,
    width: containerSize().w * dpr(),
    height: containerSize().h * dpr(),
  },
  render: { antialias: true, antialiasGL: true, roundPixels: false },
  scene: [Boot, Lobby, WaitingRoom, Game, UI, GameOver, Leaderboard, Shop],
}

const game = new Phaser.Game(config)
;(window as any).__game = game
import { useGameStore as __s } from "@/store/gameStore"
;(window as any).__store = __s

// 백킹 스토어 = 컨테이너크기 × dpr, CSS 표시 크기 = 컨테이너크기 → 선명하게 표시
function applyResolution() {
  const d = dpr()
  const { w, h } = containerSize()
  game.scale.resize(w * d, h * d)
  game.canvas.style.width = w + 'px'
  game.canvas.style.height = h + 'px'
}
applyResolution()
let resizeTimer: number | undefined
window.addEventListener('resize', () => {
  if (resizeTimer) clearTimeout(resizeTimer)
  resizeTimer = window.setTimeout(applyResolution, 150)
})

// PWA: 서비스워커 등록(홈 화면 설치 + 오프라인). dev 서버에선 건너뜀.
if ('serviceWorker' in navigator && location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* noop */ })
  })
}
